import { render } from "./AddNewOrganization.vue?vue&type=template&id=7e715806&scoped=true"
import script from "./AddNewOrganization.vue?vue&type=script&lang=js"
export * from "./AddNewOrganization.vue?vue&type=script&lang=js"

import "./AddNewOrganization.vue?vue&type=style&index=0&id=7e715806&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e715806"]])

export default __exports__